import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';
import RoleBasedRoute from '../components/RoleBasedRoute';
import { isMcpAdminEnabled } from '../utils/mcpAdmin';

import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import CustomersPage from '../pages/CustomersPage';
import QueriesPage from '../pages/QueriesPage';
import FollowupsPage from '../pages/FollowupsPage';
import BookingsPage from '../pages/BookingsPage';
import CreatePackagePage from '../pages/CreatePackagePage';
import CreateQuotationPage from '../pages/CreateQuotationPage';
import DestinationsPage from '../pages/DestinationsPage';
import HotelsPage from '../pages/HotelsPage';
import PackagesPage from '../pages/PackagesPage';
import AttendancePage from '../pages/AttendancePage';
import TelecallingPage from '../pages/TelecallingPage';
import McpAdminPage from '../pages/McpAdminPage';
import SalesCopilotPage from '../pages/SalesCopilotPage';

const AppRoutes = () => {
  const mcpAdminEnabled = isMcpAdminEnabled();

  return (
   <AuthProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
        <Route path="/dsr" element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewDashboard"><DashboardPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewCustomers"><CustomersPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/queries" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewQueries"><QueriesPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/sales-copilot" element={<PrivateRoute><SalesCopilotPage /></PrivateRoute>} />
        <Route path="/followups" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewFollowups"><FollowupsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/bookings" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewBookings"><BookingsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/telecalling" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewTelecalling"><TelecallingPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/packages" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewPackages"><PackagesPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/package/builder" element={<PrivateRoute><RoleBasedRoute requiredPermission="canCreatePackages"><CreatePackagePage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/quotation/builder" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewQueries"><CreateQuotationPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/destinations" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewDestinations"><DestinationsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/hotels" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewHotels"><HotelsPage /></RoleBasedRoute></PrivateRoute>} />
        <Route path="/attendance" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewAttendance"><AttendancePage /></RoleBasedRoute></PrivateRoute>} />
        {mcpAdminEnabled && (
          <Route path="/admin/mcp" element={<PrivateRoute><RoleBasedRoute requiredPermission="canViewMcpAdmin" fallbackPath="/dashboard"><McpAdminPage /></RoleBasedRoute></PrivateRoute>} />
        )}
      </Routes>
    </Router>
   </AuthProvider>
  );
};

export default AppRoutes;
